import { format } from "date-fns";
import { saveAs } from "file-saver";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useExportBrandsMutation = () =>
  useTypedMutation<void, string>({
    mutationFn: async () => (await ApiInstance.get("/brands/export", ENV.carBaseURL)).data.url,
    onSuccess: (_, url) => saveAs(url, `Claire_Brands_Export_${format(new Date(), "yyyyMMddHHss")}.ods`)
  });
